const BusbarSVG = ({barPositions}) => {
    return (
         <svg>
          <g id="busbar" >
            <line
              x1={barPositions.x1}
              y1={barPositions.y1}
              x2={barPositions.x2}
              y2={barPositions.y2}
              stroke="var(--se-sld-circline)"
              strokeWidth="3"
            />
          </g>
        </svg>
    )
}

export default BusbarSVG;